module.exports = __webpack_public_path__ + "static/media/create-article.853a2abb.gif";